export default "__VITE_PUBLIC_ASSET__e43ddfc8__"